<template>
    <v-form>
        <div class="task_filter_container px-4 pt-4" v-if="this.lessonInfo">
            <v-row>

                <!-- Level -->                
                <v-col class="d-flex" cols="12" sm="6" md="2">
                    <v-select
                        dense
                        v-model="level"
                        :items="levelsOrder"
                        label="Nivel"
                        outlined
                        rounded
                        :item-text="item => item.name"
                        :item-value="item => item.categoryId"
                    ></v-select>
                </v-col>

                <!-- Cource -->
                <v-col class="d-flex" cols="12" sm="6" md="2">
                    <v-select
                        dense
                        v-model="cource"
                        :items="this.sectionsItems"
                        label="Curso"
                        outlined
                        rounded
                        :item-text="item => item.abbreviation"
                        :item-value="item => item.sectionId"
                    ></v-select>
                </v-col>
                <!-- subject -->
                <v-col cols="12" sm="6" md="2">
                    <v-select
                        dense
                        v-model="subject"
                        :items="subjectListFiltered"
                        label="Asignatura"
                        outlined
                        rounded
                        :item-text="item => capitalizeFirstLetter(item.name)"
                        :item-value="item => item.subjectId"
                    ></v-select>
                </v-col>

                <!--<v-col>
                    <v-select
                        dense
                        v-model="subject"
                        :items="lessonInfo.subjectList"
                        label="Asignatura"
                        outlined
                        rounded
                        :item-text="item => capitalizeFirstLetter(item.name)"
                        :item-value="item => item"
                    ></v-select>
                </v-col>
                <v-col>
                    <GroupSelect
                        :items="currentSubject"
                        placeholder="Nivel"
                        :setData="setNivel"
                        :required="true"
                        :updateMode="{
                            status: $route.params.id ? true : false,
                            currentSelected: $route.params.id
                                ? getLesson.category.categoryId
                                : ''
                        }"
                    />
                </v-col>
                <v-col>
                    <v-select
                        dense
                        v-model="cource"
                        :items="this.sectionsItems"
                        label="Curso"
                        outlined
                        rounded
                        :item-text="item => item.nameAndCategoryName"
                        :item-value="item => item.sectionId"
                    ></v-select>
                </v-col>-->
                
               <v-col>
                    <v-select
                        dense
                        v-model="estado"
                        :items="this.estados"
                        label="Estado"
                        outlined
                        rounded
                        :item-text="item => item.name"
                        :item-value="item => item.id"
                    ></v-select>
                </v-col>
                
                <v-col class=" d-flex justify-center">
                    <v-btn
                        rounded
                        color="blue lighten-1"
                        dark
                        elevation="1"
                        @click="search()"
                    >
                        <v-icon left> mdi-magnify </v-icon>Buscar</v-btn
                    >
                </v-col>
            </v-row>
        </div >
    </v-form>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
//import GroupSelect from "@/components/commons/RomaGroupSelect";

export default {
    //components: { GroupSelect },
    data() {
        return {
            title: "",
            code: "",
            pie: false,
            description: ``,
            subject: "",
            level: "",
            cource: "",
            unit: "",
            planUnit: "",
            activity: "",
            week: "",
            dialog: false,
            estado:"",
			estados : [{id:'POR_ENVIAR',name:'POR RECIBIR'},{id:'PENDIENTE',name:'POR EVALUAR'},{id:'REVISADO',name:'EVALUADO'}],
            sectionsItems: [],

            // validations
            requiredRules: [v => !!v || "Este campo es requerido"],
            editorIsEmpty: false,
            subjectListFiltered:[],
            fullCategories:[]
        };
    },
    mounted(){
     this.actionSetSearchQuery("");
    },
    destroyed(){
     this.actionSetSearchQuery(""); 
    }
    ,
    computed: {
        ...mapGetters({
            lessonInfo: "getLessonInformation"
        }),
        // availableSubmit() {
        //     const availableSubmit =
        //         !!this.title &&
        //         !!this.code &&
        //         !!this.description &&
        //         !!this.subject &&
        //         !!this.level &&
        //         !!this.cource &&
        //         !!this.unit;

        //     // &&
        //     // !!this.planUnit &&
        //     // !!this.activity &&
        //     // !!this.week;

        //     return availableSubmit;
        // },
        // avalibleUpdate() {
        //     const avalibleUpdate =
        //         this.title === this.getLesson.title &&
        //         this.code === this.getLesson.code &&
        //         this.description === "" &&
        //         this.level === "" &&
        //         this.cource === this.getLesson.section.sectionId &&
        //         this.subject === this.getLesson.subject.name &&
        //         this.unit === this.getLesson.unit.unitId;
        //     return avalibleUpdate;
        // },
        currentSubject() {
            const subjectList = this.lessonInfo.subjectList
                ? this.lessonInfo.subjectList
                : [];
            const currentSubject = subjectList.filter(subject => {
                return subject.name === this.subject.name;
            });
            return currentSubject;
        },
        levelsOrder(){

        const fullCategories = [];
            this.lessonInfo.educationList.forEach(education => {
                    education.categories.forEach(category=>{
                        fullCategories.push(category);
                    }
                );

            });

            return fullCategories;
        },
        currentEducations() {
            const educations = this.currentSubject[0]
                ? this.currentSubject[0].educations
                : [];

            // deconstruct Educations
            const newArr = [];
            educations.forEach(item => {
                newArr.push({
                    header: item.name
                });
                item.categories.forEach(category => {
                    newArr.push(category);
                });
                newArr.push({ divider: true });
            });
            return newArr;
        },
        currentSubjectList() {
            return this.lessonInfo ? this.lessonInfo.subjectList : [];
        },
        currentInstitutionId() {
            return this.user && this.user.institutionContext
                ? this.user.institutionContext.institutionId
                : [];
        }
    },
    watch: {
        cource: function(){

            console.log("course (section id) Selected:",this.cource);
            this.subjectListFiltered = [];
            this.lessonInfo.subjectList.forEach(subject => {
                let aux = false;
                subject.educations.forEach( education => {
                    education.categories.forEach( category => {
                            category.sections.forEach( section => {
                                if(section.sectionId == this.cource){
                                    aux = true;
                                }
                            });
                    });
                });

                if(aux === true ){
                    this.subjectListFiltered.push(subject);
                }

            });

        },
        subject() {

            console.log(this.subject);

            if (this.unit) {
                // this.planUnit ? this.planUnit = "" : '';

                this.actionGetPlanUnits({
                    idUnidad: this.unit,
                    idAsignatura: this.currentSubject[0].subjectId
                });
            }
        },
        unit(newValue, oldValue) {
            // this.planUnit = "";
            this.actionGetPlanUnits({
                idUnidad: newValue,
                idAsignatura: this.currentSubject[0].subjectId
            });
        },

        planUnit(newValue, oldValue) {
            // console.log(newValue);
            this.actionGetPlanUnitActivities(newValue);
            this.actionGetWeeks(newValue);
        },
        level: function() {
            // se limpia select cource
            if (!this.$route.params.id) {
                this.cource = null;
            }

            // AUXILIAR NIVEL EDUCATIVO

            //let aux = 0;
            console.log("level Selected:",this.level);

            // Niveles de eduacion (Basico / Medio)
            //this.currentSubject[0].educations.forEach(educationLevel => {
            /*this.lessonInfo.educationList.forEach(educationLevel => {
                // Niveles (1ero, 2do, 3ro, ...)
                const grado = educationLevel.categories.findIndex(
                    level => level.categoryId == this.level
                );

                if (grado != -1) {
                    aux = this.lessonInfo.educationList.findIndex(
                        element => element == educationLevel
                    );
                }
            });*/

            //console.log("aux Selected:",aux);

            //const categories = this.lessonInfo.educationList[aux].categories
            //    ? this.lessonInfo.educationList[aux].categories
            //    : [];

            const courses = this.lessonInfo.courseList;
 
            const index = courses.findIndex(
                course => course.category.categoryId == this.level
            );

            /*const index = categories.findIndex(
                categoria => categoria.categoryId == this.level
            );*/

            if(courses[index] !== undefined){
                const cursos = courses[index].sections;
                this.sectionsItems = cursos;
            }else{
                this.sectionsItems = [];
            }


            
        }
    },
    methods: {
        ...mapActions({
            actionGetTasks: "actionGetTasks",
            actionSetSearchQuery: "actionSetSearchQuery"
        }),
        setNivel(level) {
            this.level = level;
        },
        search() {

            const sectionId = this.cource ? `&sectionId=${this.cource}` : "";
            const subjectId = this.subject
                ? `&subjectId=${this.subject}`
                : "";

            const level = this.level ? `&categoryId=${this.level}` : "";
            const estado = this.estado ? `&state=${this.estado}` : "";

            // const institutionId = this.user.institutionContext.institutionId
            //     ? `&institutionId=${this.user.institutionContext.institutionId}`
            //     : "";
            // const personId = this.user.personId
            //     ? `&personId=${this.user.personId}`
            //     : "";
            // const unitId = this.unit ? `&unitId=${this.unit}` : "";
            // const title = this.searchText ? `&title=${this.searchText}` : "";



            const query = `${sectionId}${subjectId}${level}${estado}`;

            this.actionSetSearchQuery(query);

            this.actionGetTasks({
                searchQuery: query,
                pageNumber: 0,
                pageSize: 8
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";

.task_filter_container {
    width: 100%;
    margin-top: 1rem;
    padding-bottom: 0%;
    background: #ffffff;
    border-radius: 5px;
    //   padding: 1rem;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
        0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
